import {getDatadogRum} from '../../util/datadog/datadogRum';
import {makeTrackEvent} from './makeTrackEvent';

type DiscoverType = 'registries' | 'collections' | 'versions';

export type TrackRegistriesEvent = {
  action: 'type_changed' | 'tab_changed';
  organizationName: string;
  discoverType?: DiscoverType;
  previousType?: DiscoverType;
  organizationID?: string;
  entityName?: string;
  newTab?: string;
  previousTab?: string;
  registryName?: string;
};

const trackRegistriesInteraction = makeTrackEvent<
  TrackRegistriesEvent,
  {
    action: {
      description: 'The registries interaction action.';
      exampleValues: ['type_changed', 'tab_changed'];
    };
    discoverType: {
      description: 'The newly selected discover type in registries discover.';
      exampleValues: ['registries', 'collections', 'versions'];
    };
    previousType: {
      description: 'The previously selected discover type in registries discover.';
      exampleValues: ['registries', 'collections', 'versions'];
    };
    organizationID: {
      description: 'Organization identifier for the registries interaction.';
      exampleValues: ['<hash>'];
    };
    organizationName: {
      description: 'Organization name for the registries interaction.';
      exampleValues: ['<name>'];
    };
    entityName: {
      description: 'Registry entity name associated with a tab interaction.';
      exampleValues: ['<name>'];
    };
    newTab: {
      description: 'The new tab selected in RegistryPage.';
      exampleValues: ['collections', 'automations', 'automations-history'];
    };
    previousTab: {
      description: 'The previous tab selected in RegistryPage.';
      exampleValues: ['collections', 'automations'];
    };
    registryName: {
      description: 'The registry name where the tab interaction occurred.';
      exampleValues: ['model', 'dataset'];
    };
    _description: 'Tracks user interactions with registries discover type and registry tabs.';
    _location: 'registries pages';
    _motivation: 'Understand how users navigate registries surfaces and tabs over time.';
  }
>('Registries Interaction');

export function trackRegistriesEvent(eventData: TrackRegistriesEvent): void {
  trackRegistriesInteraction(eventData);
  getDatadogRum().addAction(`Registries.${eventData.action}`, eventData);
}
